<div class="row">
    <div class="col-xl-12 mb-5 mb-xl-0">
        <div class="card shadow">
            <nav aria-label="breadcrumb">
              <ol class="breadcrumb">
                <li class="breadcrumb-item"><a routerLink="/">Home</a></li>
                <li class="breadcrumb-item"><a routerLink="/settings">Settings</a></li>
                <li class="breadcrumb-item active" aria-current="page">Customer Details</li>
              </ol>
            </nav>
            <div class="card-header border-0">
                <div class="row align-items-center">
                    <div class="col">
                        <h2 class="mb-0">Customer Details</h2>
                    </div>
                </div>
            </div>
            <div class="container">
                <app-kyc *ngIf="account" [account]="account"></app-kyc>
            </div>
            <div class="card-body">
            </div>
        </div>
    </div>
</div>
